import React from 'react';
import './SingleLarge.less';

interface SingleLargeState {

}

interface SingleLargePropType {
    prefixCls?: string;
    floorId: any;
    floorTemplate: any[];
    onFloorClick: Function;
}

class SingleLarge extends React.Component<SingleLargePropType, SingleLargeState> {
    static defaultProps = {
        prefixCls: 'singleLarge',
    };

    render() {
        const {prefixCls, floorId, floorTemplate, onFloorClick} = this.props;
        return (
            <div className={prefixCls}>
                <div className={`${prefixCls}imgBox`} onClick={() => {
                    onFloorClick && onFloorClick(floorId, floorTemplate[0].moduleName, floorTemplate[0].moduleUrlType, floorTemplate[0].moduleUrl);
                }}>
                    <img src={floorTemplate[0].moduleImgUrl} alt=""/>
                </div>
            </div>
        );
    }
}

export default SingleLarge;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/floorModule/singleLarge/SingleLarge.tsx